import { Controller } from "@hotwired/stimulus"

// Upload form validation controller
// Ensures Google Drive folder is selected before allowing form submission
export default class extends Controller {
  static targets = ["submitButton", "folderIdField"]

  connect() {
    console.log("[UploadFormValidation] Controller connected")
    this.validateForm()
  }

  // Validate form whenever folder selection changes
  validateForm() {
    // Check if Google Drive checkbox is checked and enabled
    const googleDriveCheckbox = document.getElementById('upload_to_google_drive')

    if (!googleDriveCheckbox || !googleDriveCheckbox.checked || googleDriveCheckbox.disabled) {
      // Google Drive not selected, validation not needed
      this.enableSubmit()
      return
    }

    // Google Drive is selected - check if folder is selected
    const folderIdInput = document.querySelector('input[name="google_drive_folder_id"]')
    const folderId = folderIdInput?.value

    if (!folderId || folderId.trim() === '') {
      // No folder selected - disable submit
      this.disableSubmit("Please select a Google Drive folder")
    } else {
      // Folder selected - enable submit
      this.enableSubmit()
    }
  }

  disableSubmit(message) {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.title = message
      this.submitButtonTarget.classList.add('opacity-50', 'cursor-not-allowed')
    }
  }

  enableSubmit() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = false
      this.submitButtonTarget.title = ""
      this.submitButtonTarget.classList.remove('opacity-50', 'cursor-not-allowed')
    }
  }

  // Called when form is about to be submitted
  validateBeforeSubmit(event) {
    const googleDriveCheckbox = document.getElementById('upload_to_google_drive')

    if (!googleDriveCheckbox || !googleDriveCheckbox.checked || googleDriveCheckbox.disabled) {
      // Google Drive not selected, validation not needed
      return true
    }

    // Google Drive is selected - check if folder is selected
    const folderIdInput = document.querySelector('input[name="google_drive_folder_id"]')
    const folderId = folderIdInput?.value

    if (!folderId || folderId.trim() === '') {
      event.preventDefault()
      event.stopPropagation()

      // Show error message
      this.showError("Please select a Google Drive folder before uploading.")
      return false
    }

    return true
  }

  showError(message) {
    // Create or update error alert
    const alertHtml = `
      <div class="rounded-md bg-red-50 border border-red-200 p-4 mb-4" id="form-validation-error">
        <div class="flex">
          <div class="flex-shrink-0">
            <svg class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm font-medium text-red-800">${message}</p>
          </div>
        </div>
      </div>
    `

    // Remove existing error
    const existingError = document.getElementById('form-validation-error')
    if (existingError) {
      existingError.remove()
    }

    // Insert error before the form
    const form = this.element
    if (form) {
      form.insertAdjacentHTML('beforebegin', alertHtml)

      // Scroll to error
      const errorElement = document.getElementById('form-validation-error')
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }

      // Auto-dismiss after 10 seconds
      setTimeout(() => {
        const alert = document.getElementById('form-validation-error')
        if (alert) {
          alert.remove()
        }
      }, 10000)
    }
  }
}
